import React from 'react'
import styled, { css } from 'react-emotion'
import {
  color,
  spacer,
  transparentize,
  typography,
  Loader,
  SecondaryLink,
  TrashIcon,
  fontWeight
} from 'stylist'
import ProgressBar from 'components/ProgressBarV2'
import CancelCircle from 'components/icons/CancelCircle'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const Main = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  padding: ${spacer(6)} ${spacer(4)};
`

const UploadProgress = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const TileTitle = styled.div`
  font-style: italic;
  ${typography('body2Medium')};
  ${({ center }) =>
    center &&
    css`
      text-align: center;
    `};
  ${({ error, theme }) =>
    error &&
    css`
      color: ${color('red', { theme })};
      font-style: italic;
    `};
`

const StyledCancelCircle = styled(CancelCircle)`
  margin-left: ${spacer(2)};
  cursor: pointer;
`

const TileCaption = styled.div`
  ${fontWeight('bold')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacer(5)};
  color: ${color('white')};
  height: calc(${spacer(5)} * 2 + 16px);
  background-color: ${({ error, cancelled }) =>
    error ? color('red') : cancelled ? color('pewter') : color('ocean')};
`

const TileTitleForCancel = styled.div`
  align-items: center;
  margin: 0 auto;
  ${typography('body2Medium')};
`

const StyledLoader = styled(Loader)`
  margin-left: ${spacer(2)};
`

const StyledSecondaryLink = styled(SecondaryLink)`
  margin-top: ${spacer(3)};
  text-align: center;
`

const TrashIconButton = styled.button`
  position: absolute;
  right: ${spacer(5)};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${transparentize('white', 0.2)};
  color: ${color('white')};
  border: none;
  width: 2rem;
  height: 2rem;
  cursor: pointer;

  &:hover {
    background-color: ${transparentize('white', 0.3)};
  }
`

export const Error = ({
  title,
  supportLink,
  supportLinkLabel,
  file,
  handleRemove
}) => (
  <Container>
    <Main>
      <TileTitle error center>
        {title}
      </TileTitle>
      <StyledSecondaryLink external target="_blank" href={supportLink}>
        {supportLinkLabel}
      </StyledSecondaryLink>
    </Main>
    <TileCaption error>
      {file.name}
      <TrashIconButton onClick={handleRemove}>
        <TrashIcon size="1.25rem" />
      </TrashIconButton>
    </TileCaption>
  </Container>
)

const Cancelled = ({ file }) => (
  <Container>
    <Main>
      <TileTitleForCancel>
        Canceling Upload
        <StyledLoader size="sm" />
      </TileTitleForCancel>
    </Main>
    <TileCaption cancelled>{file.name}</TileCaption>
  </Container>
)

const InProgress = ({ file, progress, handleCancel }) => (
  <Container>
    <Main>
      <TileTitle>Uploading File...</TileTitle>
      <UploadProgress>
        <ProgressBar progress={progress} />
        <StyledCancelCircle color="cadet" onClick={() => handleCancel()} />
      </UploadProgress>
    </Main>
    <TileCaption>{file.name}</TileCaption>
  </Container>
)

const VideoUploadProgressTile = ({
  state,
  progress,
  uuid,
  abortUpload,
  removeUpload,
  file
}) => {
  switch (state) {
    case 'cancelled':
      return <Cancelled file={file} />
    case 'error':
      return (
        <Error
          title="Upload Failed"
          supportLink="https://focusvision.zendesk.com/hc/en-us/articles/360012946594"
          supportLinkLabel="Why did my upload fail?"
          file={file}
          handleRemove={() => removeUpload({ uuid })}
        />
      )
    default:
      return (
        <InProgress
          file={file}
          progress={progress}
          handleCancel={() => {
            abortUpload({ uuid })
            setTimeout(() => removeUpload({ uuid }), 1500)
          }}
        />
      )
  }
}

export default VideoUploadProgressTile



// WEBPACK FOOTER //
// ./src/routes/videos/components/VideoUploadProgressTile.js